/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createTrue } from '../../factoriesAny.js';
export var trueDependencies = {
  createTrue
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesTrue.generated.js
// module id = 1495
// module chunks = 2